
import '../postcss/menu.css';
/*
Array.from(document.getElementsByTagName('path')).map(path => {
    console.log(path.getTotalLength());
    const debugPath = path.cloneNode();
    debugPath.classList.add('line--debug');
    if (path.parentNode) path.parentNode.insertBefore(debugPath.cloneNode(), path);
});
/*
const debugCheckbox = document.getElementById('debug');
debugCheckbox.addEventListener('change', () => {
    if (debugCheckbox.checked) {
        debugCheckbox.parentElement.classList.add('active');
    } else {
        debugCheckbox.parentElement.classList.remove('active');
    }
});

 */
/*
let currentActive = 0;
const checkboxes = document.querySelectorAll('.grid input');
const autoShow = setInterval(() => {
    checkboxes[currentActive % 4].checked = !checkboxes[currentActive % 4].checked;
    if (!checkboxes[currentActive % 4].checked) currentActive += 1;
}, 1000);
document.querySelector('.grid').addEventListener('click', () => {
    clearInterval(autoShow);
})
*/

let animateElem = document.getElementsByTagName("path");
console.log(animateElem);
//animateElem[0].addEventListener('endEvent', () => {
 //   console.log(this);
//})
animateElem[0].onend = () => {
    console.log('endEvent fired');
}

// section1
class TextScramble {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases = [
    'PLAY,',
    'EAT,',
    'DRINK',
    'DART FLEX'
]

const el = document.querySelector('.sec1 .rt .txt_wrap .bold')
const fx = new TextScramble(el)

let counter = 0

const next = () => {

  //  console.log(phrases.length);
    if(counter===phrases.length){
        counter=0;
        return false;
    }
    fx.setText(phrases[counter]).then(() => {

        setTimeout(next, 800)
    })
  //  counter = (counter + 1) % phrases.length
    counter += 1;

  //  console.log(counter);
}

next();
///////////////////////////////////////////////////////////////////////////

// section2
class TextScramble2 {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
            // const length =oldText.length;
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases2 = [
    // 'What',
    // 'What is',
    'What is DART FLEX'
]

const el2 = document.querySelector('.sec2 .rt .txt_wrap .bold')
const fx2 = new TextScramble2(el2)

let counter2 = 0
const next2 = () => {
    if(counter2===phrases2.length){
        counter2=0;
        return false;
    }
    fx2.setText(phrases2[counter2]).then(() => {
        setTimeout(next2, 800)
    })
   // counter2 = (counter2 + 1) % phrases2.length
    counter2++;
    //if(counter2>phrases2.length){
    //    return false;
   // }
}

//next2()
///////////////////////////////////////////////////////////////////////////

// section3
class TextScramble3 {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases3 = [
    'DART FLEX'
]

const el3 = document.querySelector('.sec3 .rt .txt_wrap .bold')
const fx3 = new TextScramble3(el3)

let counter3 = 0
const next3 = () => {
    if(counter3===phrases3.length){
        counter3=0;
        return false;
    }
    fx3.setText(phrases3[counter3]).then(() => {
        setTimeout(next3, 800)
    })
   // counter3 = (counter3 + 1) % phrases3.length
    counter3++;


}

//next3()
///////////////////////////////////////////////////////////////////////////

// section4
class TextScramble4 {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases4 = [
    '매장별 안내'
]

const el4 = document.querySelector('.sec4 .rt .txt_wrap .bold')
const fx4 = new TextScramble4(el4)

let counter4 = 0
const next4 = () => {
    if(counter4===phrases4.length){
        counter4=0;
        return false;
    }
    fx4.setText(phrases4[counter4]).then(() => {
        setTimeout(next4, 800)
    })
   // counter4 = (counter4 + 1) % phrases4.length
    counter4++;
  //  if(counter4>phrases4.length){
 //       return false;
 //   }
}

//next4()
///////////////////////////////////////////////////////////////////////////

// section5
class TextScramble5 {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases5 = [
    '매장별 안내'
]

const el5 = document.querySelector('.sec5 .rt .txt_wrap .bold')
const fx5 = new TextScramble5(el5)

let counter5 = 0
const next5 = () => {
    if(counter5===phrases5.length){
        counter5=0;
        return false;
    }
    fx5.setText(phrases5[counter5]).then(() => {
        setTimeout(next5, 800)
    })
   // counter5 = (counter5 + 1) % phrases5.length
    counter5++;

}

////next5()
///////////////////////////////////////////////////////////////////////////

// section6
class TextScramble6 {
    constructor(el) {
        this.el = el
        this.chars = '!<>-_\\/[]{}—=+*^?#________'
        this.update = this.update.bind(this)
    }
    setText(newText) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 40)
            const end = start + Math.floor(Math.random() * 40)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class="dud">${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)]
    }
}

const phrases6 = [
    'SNS로 만나는 다트플렉스'
]

const el6 = document.querySelector('.sec6 .rt .txt_wrap .bold')
const fx6 = new TextScramble6(el6)

let counter6 = 0
const next6 = () => {
    if(counter6===phrases6.length){
        counter6=0;
        return false;
    }
    fx6.setText(phrases6[counter6]).then(() => {
        setTimeout(next6, 800)
    })
  //  counter6 = (counter6 + 1) % phrases6.length
    counter6++;
  //  if(counter6>phrases6.length){
  //      return false;
  //  }
}

//next6()

/* if( $(window).width() < 768 ) { const el6 = ''; } */
///////////////////////////////////////////////////////////////////////////
function   slide_down(){
    alert('down');
}
function   slide_up(){
    alert('up');
}
var ts;
$(document).ready(function () {

   // next();
    $('#snsDiv').on('load', function(){
        //alert($(this).contents().find('body'));
        console.log( $(this).contents().find('body'));
        var obj = $(this).contents();

        this.addEventListener('touchmove', event => {
            const touch = event.touches[0]

            console.log([touch.clientX, touch.clientY])
        })
        this.addEventListener('click', event => {
          //  const touch = event.touches[0]
//alert('11');
          //  console.log([touch.clientX, touch.clientY])
        })
      //$(this.contentDocument).find('body').html('This frame was modified with jQuery! Yay!!!')
    });



    $("#snsDiv").contents().click(function(event){
   //    alert( event.target.nodeName);
    })
    $('#snsDiv').on('touchstart',function(){

   //  alert(1);

    });
    $(".transparent_div").on('touchstart', function (e){
  //      alert('1');
       // $(".transparent_div").hide();
      //  alert('1');
    });

    $(".transparent_div").on('touchend', function (e){
     //   alert('2');
      ///  alert('2');
    /*    var te = e.originalEvent.changedTouches[0].clientY;
        if(ts > te+5){
            slide_down();
        }else if(ts < te-5){
            slide_up();
        }*/
        $(".transparent_div").show();
    });




    $(".top_btn").css("display", "none");

    $('#fullpage').fullpage({
        anchors: ['sec1', 'sec2', 'sec3', 'sec4', 'sec5', 'sec6'],
        navigation:false,
        showActiveTooltip: true,
        continuousVertical: false,
        scrollingSpeed: 600,
        responsiveSlides: true,
        fixedElements: '.quick',
        css3: true,
        easingcss3: 'cubic-bezier(0, 0.9, 0.95, 1)',

        // 특정 인덱스일 때
        afterLoad: function (anchorLink, index) {

            if (index == 1) {
                $(".top_btn").css("display", "none");
                $(".scroll_btn").css("display", "block");
                $(".quick_wrapper").css("bottom" , "7%");
                next();
            } else if (index == 2) {
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                $(".quick_wrapper").css("bottom" , "7%");
                next2();
            } else if (index == 3) {
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                $(".quick_wrapper").css("bottom" , "7%");
                next3();
            } else if (index == 4) {
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                $(".quick_wrapper").css("bottom" , "7%");
                next4();
            } else if (index == 5) {
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                $(".quick_wrapper").css("bottom" , "7%");
                next5();
            } else if (index == 6) {
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "none");
                $(".quick_wrapper").css("bottom" , "7%");
                next6();
                if( $(window).width() < 768 ) {
                    $(".quick_wrapper").css("bottom" , "15%");
                }
            }
            //console.log(index);
        },

        // 페이지 이동할 때
        onLeave: function (index, nextIndex, direction) {

            if (index == 1 && direction == 'down') {
                $(".quick_wrapper > div:nth-child(2)").addClass("active");
                $(".quick_wrapper > div:nth-child(2)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                next2();
                //console.log('1번에서 2번으로');
            } else if (index == 2 && direction == 'down') {
                $(".quick_wrapper > div:nth-child(3)").addClass("active");
                $(".quick_wrapper > div:nth-child(3)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                next3();
                //console.log('2번에서 3번으로');
            } else if (index == 3 && direction == 'down') {
                $(".quick_wrapper > div:nth-child(4)").addClass("active");
                $(".quick_wrapper > div:nth-child(4)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                next4();
                //console.log('3번에서 2번으로');
            } else if (index == 4 && direction == 'down') {
                $(".quick_wrapper > div:nth-child(5)").addClass("active");
                $(".quick_wrapper > div:nth-child(5)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                next5();
                //console.log('4번에서 5번으로');
            } else if (index == 5 && direction == 'down') {
                $(".quick_wrapper > div:nth-child(6)").addClass("active");
                $(".quick_wrapper > div:nth-child(6)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "none");
                next6();
                //console.log('5번에서 6번으로');
            } else if (index == 2 && direction == 'up') {
                $(".quick_wrapper > div:nth-child(1)").addClass("active");
                $(".quick_wrapper > div:nth-child(1)").siblings().removeClass("active");
                $(".top_btn").css("display", "none");
                $(".scroll_btn").css("display", "block");
                next();
                //console.log('2번에서 1번으로');
            } else if (index == 3 && direction == 'up') {
                $(".quick_wrapper > div:nth-child(2)").addClass("active");
                $(".quick_wrapper > div:nth-child(2)").siblings().removeClass("active");
                $(".top_btn").css("display", "flex");
                $(".scroll_btn").css("display", "block");
                next2();
                //console.log('3번에서 2번으로');
            } else if (index == 4 && direction == 'up') {
                $(".quick_wrapper > div:nth-child(3)").addClass("active");
                $(".quick_wrapper > div:nth-child(3)").siblings().removeClass("active");
                $(".scroll_btn").css("display", "block");
                next3();
                //console.log('4번에서 3번으로');
            } else if (index == 5 && direction == 'up') {
                $(".quick_wrapper > div:nth-child(4)").addClass("active");
                $(".quick_wrapper > div:nth-child(4)").siblings().removeClass("active");
                $(".scroll_btn").css("display", "block");
                next4();
                //console.log('5번에서 4번으로');
            } else if (index == 6 && direction == 'up') {
                $(".quick_wrapper > div:nth-child(5)").addClass("active");
                $(".quick_wrapper > div:nth-child(5)").siblings().removeClass("active");
                $(".scroll_btn").css("display", "block");
                //console.log('6번에서 5번으로');
                next5();
            }
        },

    });

    $(".quick1").on('click', function () {
        $.fn.fullpage.moveTo(1);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });
    $(".quick2").on('click', function () {
        $.fn.fullpage.moveTo(2);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });
    $(".quick3").on('click', function () {
        $.fn.fullpage.moveTo(3);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });
    $(".quick4").on('click', function () {
        $.fn.fullpage.moveTo(4);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });
    $(".quick5").on('click', function () {
        $.fn.fullpage.moveTo(5);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });
    $(".quick6").on('click', function () {
        $.fn.fullpage.moveTo(6);
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
    });

    $(".top_btn").click(function(){
        $.fn.fullpage.moveTo(1);
        $(".quick_wrapper > div:nth-child(1)").addClass("active");
        $(".quick_wrapper > div:nth-child(1)").siblings().removeClass("active");
    });
});


/*

$("#ham_label").on('click', function () {
    console.log(this);
    console.log($('#bergerChecker').is('checked'));
    var flag = $('#bergerChecker').val();

    if($(this).children("input").is("checked")){
        console.log("끌꺼야2");
        $(this).addClass("non_active");
        $(this).removeClass("active");
        $(".header_ham").removeClass("active");
        $('#bergerChecker').prop('checked',true);
    } else {
        $('#bergerChecker').prop('checked',false);
        console.log("킬꺼야2");
        $(this).addClass("active");
        $(this).removeClass("non_active");
        $(".header_ham").addClass("active");
    }
    if($(this).hasClass('non_active')) {
        console.log("킬꺼야2");
        $(this).addClass("active");
        $(this).removeClass("non_active");
        $(".header_ham").addClass("active");
    } else  if($(this).hasClass('active')) {
        console.log("끌꺼야2");
        $(this).addClass("non_active");
        $(this).removeClass("active");
        $(".header_ham").removeClass("active");

});
*/
